/** Static "about me" data for the home desk. Projects come from the API instead. */

export interface Hat {
  id: string;
  label: string;
  line: string;
}

export type StackGroupId = "lang" | "web" | "mobile" | "backend" | "cloud" | "ai";

export interface StackItem {
  name: string;
  group: StackGroupId;
}

export interface StackGroup {
  id: StackGroupId;
  label: string;
}

export const HATS: readonly Hat[] = [
  { id: "client", label: "Client builder", line: "Ship full-stack products for agency clients, from first commit to staging sign-off." },
  { id: "platform", label: "Platform engineer", line: "Backends, APIs and infra that other teams build on." },
  { id: "founder", label: "Founder", line: "Building my own products and holding them to the client bar." },
  { id: "lead", label: "Tech lead", line: "Reviewing, directing and unblocking other engineers." },
  { id: "creator", label: "Creator", line: "Teaching developers in Tamil and building in public every week." },
];

export const STACK_GROUPS: readonly StackGroup[] = [
  { id: "lang", label: "Languages" },
  { id: "web", label: "Web" },
  { id: "mobile", label: "Mobile" },
  { id: "backend", label: "Backend" },
  { id: "cloud", label: "Cloud" },
  { id: "ai", label: "AI" },
];

export const STACK: readonly StackItem[] = [
  { name: "TypeScript", group: "lang" },
  { name: "Python", group: "lang" },
  { name: "Go", group: "lang" },
  { name: "Swift", group: "lang" },
  { name: "React", group: "web" },
  { name: "Next.js", group: "web" },
  { name: "React Native", group: "mobile" },
  { name: "Expo", group: "mobile" },
  { name: "Node.js", group: "backend" },
  { name: "Hono", group: "backend" },
  { name: "Django", group: "backend" },
  { name: "PostgreSQL", group: "backend" },
  { name: "Drizzle", group: "backend" },
  { name: "Docker", group: "backend" },
  { name: "AWS", group: "cloud" },
  { name: "Cloudflare", group: "cloud" },
  { name: "GCP", group: "cloud" },
  { name: "Firebase", group: "cloud" },
  { name: "Supabase", group: "cloud" },
  { name: "Vercel", group: "cloud" },
  { name: "Claude", group: "ai" },
  { name: "MCP", group: "ai" },
  { name: "Agents", group: "ai" },
  { name: "Whisper", group: "ai" },
];

/** A section of the site, shown as a folder on the home shelf. */
export interface DeskSection {
  to: string;
  name: string;
  line: string;
}

/** An external place to find me, shown as a luggage tag. */
export interface Channel {
  kind: string;
  label: string;
  line: string;
  href: string;
}

export interface CallToAction {
  label: string;
  href: string;
}

export const DESK_SECTIONS: readonly DeskSection[] = [
  { to: "/vault", name: "Vault", line: "Tools, reads and references worth keeping." },
  { to: "/prompts", name: "Prompts", line: "AI prompts tested in real work." },
  { to: "/ritual", name: "Ritual", line: "Weekly build-in-public notes." },
  { to: "/projects", name: "Projects", line: "Things I've shipped, open source and otherwise." },
];

export const CHANNELS: readonly Channel[] = [
  { kind: "Instagram", label: "code.with.mapla", line: "Developer education in Tamil.", href: "https://www.instagram.com/code.with.mapla/" },
  { kind: "YouTube", label: "code_with_mapla", line: "Developer education in Tamil, on video.", href: "https://www.youtube.com/@code_with_mapla" },
  { kind: "Instagram", label: "thedevlabs.io", line: "The Dev Labs.", href: "https://www.instagram.com/thedevlabs.io/" },
  { kind: "GitHub", label: "akhshyganesh", line: "Open source, MIT almost everywhere.", href: "https://github.com/akhshyganesh" },
];

export const LEARN_CTA: CallToAction = {
  label: "Learn with me at learn.thedevlabs.io ↗",
  href: "https://learn.thedevlabs.io",
};
